module.exports = __webpack_public_path__ + "static/media/cmd_move.3db1d0e2.png";